import { Skeleton } from 'ui-library/components/Skeleton/Skeleton';
import s from './SharedWithMeDropdown.module.scss';

export const SharedWithMeItemSkeleton = () => {
  'use memo';

  return (
    <div className={s.notificationItem}>
      <div className={s.itemHeader}>
        <Skeleton variant="circular" width={28} height={28} />
        <Skeleton variant="text" width="55%" height={12} />
        <Skeleton variant="text" width={36} height={12} className={s.skeletonDate} />
      </div>
      <div className={s.itemBody}>
        <Skeleton variant="rounded" height={58} />
      </div>
    </div>
  );
};
